// business logic requirements in soft closing mode - stay on end of operation page
// if user dont registered and has invitationId
export const isValidBySoftClosingMode = (invitationId: string | null, softCloseMode?: boolean, isRegistered?: boolean) => {
    return !softCloseMode || isRegistered || !invitationId;
};
